module.exports = __webpack_public_path__ + "play-control.c94673b1a2fc2451f8e50c6c8ef32a2d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/play-control.svg
// module id = 559
// module chunks = 9